import React from 'react';
import { DateFilterWithBadge, DateRangeOption, DateRangeType } from '@css-xp/base';
import { getFormattedDateFromTimeStamp } from '@css-xp/ppc-utils';

interface QuoteDateFilterProps {
  // placeholder is used to display the placeholder text in the date filter
  placeholder?: string;
  dateRangeOptions?: DateRangeOption[];
  // eslint-disable-next-line no-unused-vars
  onDateRangeFilterChange?: (value: DateRangeType) => void;
  // dateRangeKey is used to get the correct date range value inside `getDateRange`
  dateRangeKey?: string;
  selectedValue?: string;
  // eslint-disable-next-line no-unused-vars
  setSelectedValue?: (selected: string) => void;
}

const getAppropriateDateRangeValue = (value: any, isCustomFilter?: boolean) => {
  const skipTimeFromDate = !!isCustomFilter;
  value.to = getFormattedDateFromTimeStamp(value.to, skipTimeFromDate);
  value.from = getFormattedDateFromTimeStamp(value.from, skipTimeFromDate);

  return value;
};

const getAppropriateReversedDateRangeValue = (rangeValue: any, isCustomFilter?: boolean) => {
  const value = Object.assign({}, rangeValue);
  const skipTimeFromDate = !!isCustomFilter;
  value.from = getFormattedDateFromTimeStamp(rangeValue.to, skipTimeFromDate);
  value.to = getFormattedDateFromTimeStamp(rangeValue.from, skipTimeFromDate);

  return value;
};

export const QuoteDateFilter = ({
  placeholder,
  dateRangeOptions,
  onDateRangeFilterChange,
  dateRangeKey,
  selectedValue,
  setSelectedValue,
}: QuoteDateFilterProps) => {
  const getDateRange = (value: any, isCustomFilter?: boolean) => {
    let rangeValue = [];

    if (dateRangeKey === 'expiryDate') {
      rangeValue = isCustomFilter
        ? getAppropriateDateRangeValue(value)
        : getAppropriateReversedDateRangeValue(value, isCustomFilter);
    } else {
      // Currently, applicable for createdDate key
      rangeValue = getAppropriateDateRangeValue(value);
    }

    // Call the parent's callback function, usually for refetching the data with the new range values
    onDateRangeFilterChange && onDateRangeFilterChange(rangeValue);

    // Return the appropriate date range value
    return rangeValue;
  };

  return (
    <DateFilterWithBadge
      dateValue={getDateRange}
      selected={selectedValue}
      onSelected={(selected: string) => {
        setSelectedValue && setSelectedValue(selected);
      }}
      placeholder={placeholder}
      dateRangeOptions={dateRangeOptions}
    />
  );
};
